import React from "react";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Divider from "material-ui/Divider";

import firebase from "../lib/firebase";
import googleYoloManager from "../lib/googleYoloManager";
import { checkPermission } from "../lib/Permissions";

const styles = theme => ({
  root: theme.mixins.gutters({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "500px"
  }),
  errorMessageContainer: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
  logoutButtonContainer: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  errorMessageText: {
    textAlign: "center",
    padding: 15
  }
});

class WithPermission extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      user: firebase.auth().currentUser,
      hasRequiredPermission: false,
      checkingPermission: false
    };
  }

  componentWillMount() {
    this.unsubscribeAuthChangeListener = firebase
      .auth()
      .onAuthStateChanged(user => this.hasPermission(user));
  }

  componentWillUnmount() {
    if (this.unsubscribeAuthChangeListener) {
      this.unsubscribeAuthChangeListener();
    }
  }

  async hasPermission(user) {
    try {
      if (!user) {
        this.setState({
          user,
          checkingPermission: false,
          hasRequiredPermission: false
        });
      } else {
        this.setState({
          user,
          checkingPermission: true
        });
        const hasPermission = await checkPermission(
          user,
          this.props.permission
        );
        this.setState({
          hasRequiredPermission: hasPermission,
          checkingPermission: false
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({
        user,
        checkingPermission: false,
        hasRequiredPermission: false
      });
    }
  }

  logOutFromAccount = async () => {
    await googleYoloManager.logout();
    await firebase.auth().signOut();
    googleYoloManager.login();
  };

  render() {
    const { classes } = this.props;
    if (this.state.hasRequiredPermission) {
      return this.props.children;
    } else if (this.state.user) {
      return (
        <div className={classes.root}>
          {!this.state.checkingPermission && (
            <Paper className={classes.errorMessageContainer} elevation={4}>
              <div>
                <Typography type="headline" component="h3">
                  {"You don't have the required permissions"}
                </Typography>
                <Typography component="p" className={classes.errorMessageText}>
                  {`You are logged in as ${this.state.user.email}`}
                </Typography>
                <Divider />
                <div className={classes.logoutButtonContainer}>
                  <Button
                    variant="raised"
                    color="secondary"
                    onClick={this.logOutFromAccount}
                  >
                    Log Out
                  </Button>
                </div>
              </div>
            </Paper>
          )}
        </div>
      );
    }
    return null;
  }
}

export default withStyles(styles)(WithPermission);



// WEBPACK FOOTER //
// ./src/components/WithPermission.js